
export const SET_BANNER = 'SET_BANNER'
export const SET_MODAL = 'SET_MODAL'
export const UPDATE_MODAL = 'UPDATE_MODAL'
